import { GridColumn } from 'types/grid';
import { Status } from 'types/status';
import { PaymentItem } from './types';

// Payment Grid 컬럼 정의
export const paymentGridColumns: GridColumn[] = [
  { title: 'No.', key: 'no', width: 80 },
  { title: 'Order ID', key: 'orderId', width: 180 },
  { title: 'Email', key: 'email', width: 200 },
  { title: 'Created Date', key: 'createdDate', width: 180 },
  { title: 'Currency', key: 'currency', width: 100 },
  { title: 'Amount', key: 'amount', width: 120 },
  { title: 'Payment Status', key: 'paymentStatus', width: 140 },
  { title: 'Cancel Status', key: 'cancelStatus', width: 140 },
  { title: 'Refund', key: 'refund', width: 100 }
];

// Payment Status 정의 (백엔드 ENUM에 맞춤)
export const paymentStatusMap: Record<string, Status> = {
  'PENDING': { title: 'PENDING', className: 'bg-[#E6F2FE] border-[#0890F3] text-[#0890F3]' }, // 파란색
  'COMPLETED': { title: 'COMPLETED', className: 'bg-[#E6FEED] border-[#27B72D] text-[#27B72D]' }, // 초록색
  'FAILED': { title: 'FAILED', className: 'bg-[#FEE6E6] border-[#F30808] text-[#F30808]' }, // 빨간색
  'CANCELED': { title: 'CANCELED', className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' }, // 회색으로 변경
  'UNKNOWN': { title: 'UNKNOWN', className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' }
};

// Cancel Status 정의
export const cancelStatusMap: Record<string, Status> = {
  'null': { title: 'None', className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' },
  'NONE': { title: 'None', className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' },
  'CANCEL': { title: 'CANCEL', className: 'bg-[#FEE6E6] border-[#F30808] text-[#F30808]' },
  'TO_BE_REFUNDED': { title: 'To be refunded', className: 'bg-[#FFF4E6] border-[#F39C08] text-[#F39C08]' }, // 주황색 유지
  'REFUNDED': { title: 'Refunded', className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' }, // 회색으로 변경
  'UNKNOWN': { title: 'UNKNOWN', className: 'bg-white border-[#8F8F8F] text-[#8F8F8F]' }
};


// Payment Method 옵션 (백엔드 ENUM에 맞춤)
export const paymentMethodOptions = [
  { value: 0, label: 'All Methods' },
  { value: 1, label: 'Bank Transfer' },
  { value: 2, label: 'Free Usage' },
  { value: 3, label: 'Card Payment' }
];

// 탭 메뉴 상수
export const MENU_INDEX = {
  PENDING: 0,
  COMPLETE: 1,
  FAILED: 2,
  REFUNDED: 3
};

// 탭별 상태 매핑 (백엔드 ENUM에 맞춤)
export const getTabStatus = (menuIndex: number): string => {
  const statusMap = {
    [MENU_INDEX.PENDING]: 'PENDING',
    [MENU_INDEX.COMPLETE]: 'COMPLETED',
    [MENU_INDEX.FAILED]: 'FAILED',
    [MENU_INDEX.REFUNDED]: 'CANCELED'
  };
  return statusMap[menuIndex] || 'PENDING';
};

// PaymentMethod 값을 백엔드 ENUM으로 변환
export const getPaymentMethodValue = (value: number): string => {
  const methodMap = ['', 'BANK_TRANSFER', 'FREE_USAGE', 'CARD_PAYMENT'];
  return methodMap[value] || '';
};